import React from 'react';
import classNames from 'classnames';

import { Heading } from '../../sharetribe/components';

import css from './TransactionPanelSection.module.css';

// Functional component as a helper to build TransactionPanel section
const TransactionPanelSection = (props) => {
  const {
    className,
    rootClassName,
    headingClassName,
    contentClassName,
    showSection,
    headingText,
    children,
  } = props;

  if (!showSection) return null;

  const classes = classNames(rootClassName || css.root, className);
  const headingClasses = classNames(headingClassName || css.heading);
  const contentClasses = classNames(contentClassName || css.content);

  return (
    <div className={classes}>
      <Heading as='h3' rootClassName={headingClasses}>
        {headingText}
      </Heading>
      <div className={contentClasses}>{children}</div>
    </div>
  );
};

export default TransactionPanelSection;
